import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FlexContainer } from "../../Container";
import HeaderContainer from "../shared/HeaderContainer";
import StyledNav from "../shared/StyledNav";
import LinkButton from "../shared/LinkButton";
import HeaderLogo from "../shared/HeaderLogo";
import HamburgerButton from "./HamburgerButton";
import MobileMenu from "./MobileMenu";
import ExpandableLink from "./ExpandableLink";
import {StyledLink} from "./TopLink";

import theme from "../../../styles/theme";

const MobileHeaderContainer = styled(HeaderContainer)`
  display: flex;
  ${() => theme.media.desktopUp`
    display: none;
  `};
`;

const ButtonRow = styled(FlexContainer)`
  padding: 12px;
`;

const MobileNav = ({ headerData }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    if (menuOpen) {
      document.querySelector("body").classList.add("no-scroll");
    } else {
      document.querySelector("body").classList.remove("no-scroll");
    }
  });
  return (
    <div className={"mobile_only"}>
      <style>{`
      .mobile_only {display: none;}
      @media only screen and (max-width: 800px) {
        .mobile_only {display: block;}
      }`}</style>
      <MobileHeaderContainer>
        <HeaderLogo />
        <HamburgerButton
          isOpen={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        />
        <MobileMenu open={menuOpen}>
          <StyledNav>
            {headerData.links.map(link => {
              if (link.type === "dropdownLink") {
                return (
                  <ExpandableLink key={link.label} dropDownContent={link}>
                    {link.label}
                  </ExpandableLink>
                );
              }
              return (
                <StyledLink key={link.label} href={link.url}>
                  {link.label}
                </StyledLink>
              );
            })}
          </StyledNav>
          <ButtonRow>
            {headerData.buttons.map(button => {
              return (
                <LinkButton
                  key={`button_${button.label}`}
                  label={button.label}
                  href={button.url}
                  buttonType={button.type}
                  calendly={button.calendly}
                  hidden={button.hidden}
                />
              );
            })}
          </ButtonRow>
        </MobileMenu>
        {/* <TopLevelNav>
          {headerData.links.map(link => {
            if (link.type === "dropdownLink") {
              return (
                <DropdownLink key={link.label} dropDownContent={link}>
                  {link.label}
                </DropdownLink>
              );
            }
            return (
              <SmallLink key={link.label} href={link.url}>
                {link.label}
              </SmallLink>
            );
          })}
        </TopLevelNav>
        {headerData.buttons.map(link => {
          return (
            <LinkButton
              label={link.label}
              href={link.url}
              buttonType={link.type}
            />
          );
        })} */}
      </MobileHeaderContainer>
    </div>
  );
};

export default MobileNav;
